var Option = function Option() {
  return null;
};

export default Option;


//////////////////
// WEBPACK FOOTER
// ./~/rc-mentions/es/Option.js
// module id = 1495
// module chunks = 3